import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import { API_URL } from "../../../config/appConfig";
import {
  normalizeAllow,
  normalizeRoleList,
} from "../../role-management/utils/normalizeRole";

const toRoleName = (role) => {
  if (!role) return "";
  if (typeof role === "string") return role;
  return role.name || role.role || role.roleName || "";
};

/** System-user assignable roles must grant IDP permissions (idp.*). */
const isAssignableSystemRole = (role) => {
  const allow = normalizeAllow(role);
  return allow.some((permission) => /^idp\./i.test(String(permission)));
};

const getAllRoles = async ({ assignableOnly = true } = {}) => {
  try {
    const response = await API.get(
      `${API_URL.idp}/system/role`,
      "roles_list"
    ).then(handleResponse);

    const list = normalizeRoleList(response);
    // If API list has no allow[] data, keep all names (cannot filter safely).
    const hasAllowData = list.some((role) => normalizeAllow(role).length > 0);
    const filtered =
      assignableOnly && hasAllowData
        ? list.filter(isAssignableSystemRole)
        : list;

    return filtered.map(toRoleName).filter(Boolean);
  } catch {
    return [];
  }
};

export const roleService = {
  getAllRoles,
};
